// import { createStore, applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import campaign from '@store/reducers/campaign.js';
import campaigns from '@store/reducers/campaigns.js';
import integrations from '@store/reducers/integrations.js';
import payment from '@store/reducers/payment.js';
// import post from '@store/reducers/post.js';
import user from '@store/reducers/user.js';
import wizard from '@store/reducers/wizard.js';
// import wizard from '@store/slices/wizard/wizardSlice.js';
import account from '@store/slices/account/accountSlice.js';
import agentsDashboard from '@store/slices/agentsDashboard/agentsDashboardSlice.js';
import auth from '@store/slices/auth/authSlice.js';
import blocks from '@store/slices/blocks/blocksSlice.js';
import common from '@store/slices/common/commonSlice.js';
import contentCalendar from '@store/slices/contentCalendar/contentCalendarSlice.js';
import contentPlanner from '@store/slices/contentPlanner/contentPlannerSlice.js';
import crm from '@store/slices/crm/crmSlice.js';
import design from '@store/slices/design/designSlice.js';
import forward from '@store/slices/forward/forwardSlice.js';
import googleAds from '@store/slices/googleAds/googleAdsSlice.js';
import growth from '@store/slices/growth/growthSlice.js';
import notification from '@store/slices/notification/notificationSlice.js';
import pages from '@store/slices/pages/pagesSlice.js';
import posts from '@store/slices/posts/postsSlice.js';
import profileAgents from '@store/slices/profileAgents/profileAgentsSlice.js';
import profileHealth from '@store/slices/profileHealth/profileHealthSlice.js';
import settingsSlice from '@store/slices/settings/settingsSlice.js';
import spotlight from '@store/slices/spotlight/spotlightSlice.js';
import { blocksReducers } from '@store/toolkit/blocks/blocksReducers.js';
import { emailsSections } from '@store/toolkit/emailMarketing/emailMarketingReducers.js';
import emails from '@store/toolkit/emailMarketing/emailsReducer.js';
import helpers from '@store/toolkit/helpers/helpersReducer.js';
import post from '@store/toolkit/post/postReducer.js';
import products from '@store/toolkit/products/productsReducer.js';
import settings from '@store/toolkit/settings/settingsReducer.js';
import scheduler from '@store/toolkit/socialPlanner/schedulerReducer.js';
import toastr from '@store/toolkit/toastr/toastrReducer.js';
import userSetting from '@store/toolkit/userSettings/userSettingsReducer.js';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
// import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

// import createRootReducer from './reducers';
import * as sagas from './sagas';

function* rootSaga() {
  yield all(Object.values(sagas).map((saga) => saga()));
}

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

// export const history = createHashHistory();
export const history = createBrowserHistory();

export const getStore = (preloadedState) => {
  const store = configureStore({
    reducer: {
      router: connectRouter(history),

      auth,
      wizard,
      account,
      blocks,
      pages,
      forward,
      spotlight,
      notification,
      common,
      agentsDashboard,
      profileAgents,
      profileHealth,
      growth,

      ...blocksReducers,
      userSetting,
      post,
      posts,
      products,
      settings,
      settingsSlice,
      design,
      toastr,
      helpers,

      scheduler,
      contentCalendar,
      contentPlanner,
      emails,
      emailsSections,
      campaigns,
      campaign,
      integrations,
      user,
      payment,
      googleAds,
      crm,
    }, // root reducer with router state
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(sagaMiddleware),
    preloadedState,
  });

  sagaMiddleware.run(rootSaga);

  return store;
};
